/** The broadcast module's route, owned by the feature. */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const DriverBroadcastPage = lazy(() => import('./DriverBroadcastPage'));

export const broadcastRoutes: RouteObject[] = [{ path: 'driver-broadcast', element: <DriverBroadcastPage /> }];
